module.exports = __webpack_public_path__ + "img/Stemness-GBM_GSE194329.76dace79.png";